import type { AppEnvironment } from './environment.types';

export const environment: AppEnvironment = {
  production: false,
  name: 'dev',
  appUrl: 'https://dev-poc.magalinb.com',
  apiBaseUrl: '',
  auth: {
    userPoolId: '',
    userPoolClientId: '',
    domain: '',
    redirectSignIn: ['https://dev-poc.magalinb.com/'],
    redirectSignOut: ['https://dev-poc.magalinb.com/'],
  },
};
